<template>
  <aside :class="sidebarClass">
    <!-- Brand Logo -->
    <router-link :to="homeRoute" class="brand-link">
      <img src="../assets/logo.png" alt="Logo" class="brand-image img-circle elevation-3" style="opacity: .8">
      <span class="brand-text font-weight-light">みんなの勤怠</span>
    </router-link>

    <!-- Sidebar -->
    <div class="sidebar">
      <!-- Mode badge -->
      <div class="mode-badge" :class="modeBadgeClass">
        <i :class="modeIcon"></i>
        <span>{{ modeName }}</span>
      </div>

      <!-- Sidebar Menu -->
      <nav class="mt-2">
        <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
          <!-- Admin -->
          <li v-if="userPermission === 1" class="nav-item">
            <router-link to="/home" class="nav-link"><i class="nav-icon fas fa-th"></i><p>TOPページ</p></router-link>
          </li>
          <li v-if="userPermission === 1" class="nav-item">
            <router-link to="/admin/companies" class="nav-link"><i class="nav-icon fas fa-users"></i><p>登録者管理</p></router-link>
          </li>
          <!--
          <li v-if="userPermission === 1" class="nav-item">
            <router-link to="/admin/payment" class="nav-link"><i class="nav-icon fa fa-credit-card"></i><p>課金情報管理</p></router-link>
          </li>
          <li v-if="userPermission === 1" class="nav-item">
            <router-link to="/admin/advertisement" class="nav-link"><i class="nav-icon fas fa-ad"></i><p>広告管理</p></router-link>
          </li>
          -->
          <!-- Company -->
          <li v-if="userPermission === 2" class="nav-item">
            <router-link to="/company" class="nav-link"><i class="nav-icon fas fa-th"></i><p>TOPページ</p></router-link>
          </li>
          <li v-if="userPermission === 2" class="nav-item">
            <router-link to="/company/shop-list" class="nav-link"><i class="nav-icon fas fa-store"></i><p>店舗一覧</p></router-link>
          </li>
          <li v-if="userPermission === 2" class="nav-item">
            <router-link to="/company/summary" class="nav-link"><i class="nav-icon fas fa-chart-bar"></i><p>集計</p></router-link>
          </li>
          <li v-if="userPermission === 2" class="nav-item">
            <router-link to="/company/staff-list" class="nav-link"><i class="nav-icon fas fa-users"></i><p>スタッフ一覧</p></router-link>
          </li>
          <li v-if="userPermission === 2" class="nav-item">
            <router-link to="/company/company-info" class="nav-link"><i class="nav-icon fa fa-building"></i><p>会社情報</p></router-link>
          </li>
          <!-- Store -->
          <li v-if="userPermission === 3" class="nav-item">
            <router-link to="/company" class="nav-link"><i class="nav-icon fas fa-th"></i><p>TOPページ</p></router-link>
          </li>
          <li v-if="userPermission === 3" class="nav-item">
            <router-link to="/store/calendar" class="nav-link"><i class="nav-icon fas fa-calendar"></i><p>勤務カレンダー</p></router-link>
          </li>
          <li v-if="userPermission === 3" class="nav-item">
            <router-link to="/store/timecard" class="nav-link"><i class="nav-icon fas fa-list"></i><p>申請一覧</p></router-link>
          </li>
          <li v-if="userPermission === 3" class="nav-item">
            <router-link to="/store/paid-leave" class="nav-link"><i class="nav-icon fas fa-umbrella-beach"></i><p>有給管理</p></router-link>
          </li>
          <li v-if="userPermission === 3" class="nav-item">
            <router-link to="/store/shift" class="nav-link"><i class="nav-icon fas fa-table"></i><p>シフト表</p></router-link>
          </li>
          <li v-if="userPermission === 3" class="nav-item">
            <router-link to="/store/staff-list" class="nav-link"><i class="nav-icon fas fa-users"></i><p>スタッフ一覧</p></router-link>
          </li>
          <li v-if="userPermission === 3" class="nav-item">
            <router-link to="/store/info" class="nav-link"><i class="nav-icon fa fa-store"></i><p>店舗情報</p></router-link>
          </li>
        </ul>
      </nav>
    </div>
  </aside>
</template>

<script>
import { mapGetters } from 'vuex';
import Cookies from 'js-cookie';
export default {
  name: 'SideBar',
  computed: {
    ...mapGetters(['userPermission', 'shop_name']),
    // 元々のアクセス権限 (Cookie 由来)。permission は画面遷移で一時的に切り替わるため、
    // ホームリンクの計算には Cookie の値を優先する。
    realAccess() {
      const c = parseInt(Cookies.get('access') || '0', 10);
      return c || this.userPermission || 0;
    },
    sidebarClass() {
      return {
        'main-sidebar elevation-4': true,
        'sidebar-dark-primary': this.userPermission === 1,
        'sidebar-dark-success': this.userPermission === 2,
        'sidebar-dark-info': this.userPermission === 3,
      };
    },
    homeRoute() {
      // ユーザーの本来のアクセス権限に応じた TOP に戻す
      if (this.realAccess === 1) return '/home';
      if (this.realAccess === 2) return '/company';
      if (this.realAccess === 3) return '/store';
      return '/home';
    },
    modeName() {
      if (this.userPermission === 1) return '登録者管理モード';
      if (this.userPermission === 2) return '会社管理モード';
      if (this.userPermission === 3) return '店舗管理: ' + (this.shop_name || '');
      return '';
    },
    modeIcon() {
      if (this.userPermission === 1) return 'fas fa-shield-alt';
      if (this.userPermission === 2) return 'fas fa-building';
      return 'fas fa-store';
    },
    modeBadgeClass() {
      if (this.userPermission === 1) return 'mode-admin';
      if (this.userPermission === 2) return 'mode-company';
      return 'mode-store';
    },
  },
}
</script>

<style>
.sidebar-dark-success {
  background-color: #1a4731 !important;
}
.sidebar-dark-success .brand-link {
  background-color: #22543d;
  border-bottom: 1px solid #2f6e50;
}
.sidebar-dark-success .nav-sidebar .nav-link.active {
  background-color: #38a169 !important;
}
.sidebar-dark-info {
  background-color: #1a365d !important;
}
.sidebar-dark-info .brand-link {
  background-color: #2a4365;
  border-bottom: 1px solid #2c5282;
}
.sidebar-dark-info .nav-sidebar .nav-link.active {
  background-color: #3182ce !important;
}

.mode-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  margin: 12px 12px 4px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
  color: #fff;
}
.mode-badge i {
  font-size: 14px;
}
.mode-admin {
  background: rgba(99, 102, 241, 0.3);
  border: 1px solid rgba(99, 102, 241, 0.5);
}
.mode-company {
  background: rgba(52, 211, 153, 0.2);
  border: 1px solid rgba(52, 211, 153, 0.4);
}
.mode-store {
  background: rgba(96, 165, 250, 0.2);
  border: 1px solid rgba(96, 165, 250, 0.4);
}
</style>
